import React from 'react'

interface WordHighLightProps {
    word: string
    keyword: string
    style?: React.CSSProperties
    classes?: string
}

const WordHighLight: React.FC<WordHighLightProps> = props => {
    const { word, keyword } = props
    let newWord = word
    if (keyword !== '') {
        const reg = new RegExp(keyword, 'g')
        newWord = word.replace(reg, k => `<span style="color: #14cc9b; font-weight: bold">${k}</span>`)
    }

    return <span className={props.classes} dangerouslySetInnerHTML={{ __html: newWord }} style={props.style} />
}

export default WordHighLight
